import { render, staticRenderFns } from "./SearchProducts.vue?vue&type=template&id=39644abb&scoped=true&"
import script from "./SearchProducts.vue?vue&type=script&lang=ts&"
export * from "./SearchProducts.vue?vue&type=script&lang=ts&"
import style0 from "./SearchProducts.vue?vue&type=style&index=0&id=39644abb&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39644abb",
  null
  
)

export default component.exports